import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";

/* eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging */
let UrlTraits = (_dec = primitiveTrait({
  type: "string",
  name: "URL",
  description: "The base URL of the file or service."
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Force proxy",
  description: "Force the default proxy to be used for all network requests."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Cache Duration",
  description: "The cache duration to use for proxied URLs for this catalog member. If undefined, proxied URLs are effectively cachable forever. The duration is expressed as a Varnish-like duration string, such as '1d' (one day) or '10000s' (ten thousand seconds)."
}), _class = class UrlTraits extends ModelTraits {
  get url() {
    return;
  }
  get forceProxy() {
    return;
  }
  get cacheDuration() {
    return;
  }
}, _applyDecoratedDescriptor(_class.prototype, "url", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "url"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forceProxy", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "forceProxy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cacheDuration", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "cacheDuration"), _class.prototype), _class);
/* eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging */
export default UrlTraits;